import React from 'react'
import ReactCSSTransitionReplace from 'react-css-transition-replace'

const CrossFade = ({ children }) => (
  <ReactCSSTransitionReplace
    transitionName={'cross-fade'}
    transitionEnterTimeout={600}
    transitionLeaveTimeout={600}
  >
    {children}
  </ReactCSSTransitionReplace>
)

export default CrossFade
